import { render, staticRenderFns } from "./FileItem.vue?vue&type=template&id=5f4bcbee&scoped=true"
import script from "./FileItem.vue?vue&type=script&lang=js"
export * from "./FileItem.vue?vue&type=script&lang=js"
import style0 from "./FileItem.vue?vue&type=style&index=0&id=5f4bcbee&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f4bcbee",
  null
  
)

export default component.exports